"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomerOrderItem = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _ColoredBadge = require("./ColoredBadge");
var _Loading = require("./Loading");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const BlockLink = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        marginBottom: theme.spacing(3),
        borderRadius: theme.spacing(2),
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        boxShadow: _mui.SHADOW_LEVEL3,
        cursor: 'pointer'
    };
});
const MerchContentWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        padding: theme.spacing(3, 0),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(4, 0)
        }
    };
});
const MerchHeader = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        fontSize: theme.typography.body1.fontSize,
        fontWeight: 'bold',
        color: theme.palette.text.primary,
        [theme.breakpoints.up('md')]: {
            marginBottom: theme.spacing(1)
        }
    };
});
const MerchContent = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        position: 'relative',
        display: 'inline-block',
        paddingRight: theme.spacing(3),
        fontSize: theme.typography.caption.fontSize,
        fontWeight: 'normal',
        color: theme.palette.text.primary,
        [theme.breakpoints.up('md')]: {
            paddingRight: theme.spacing(6),
            fontSize: theme.typography.body1.fontSize
        }
    };
});
const ArrowIcon = (0, _mui.styled)(_icons.ArrowRightThin)((param)=>{
    let { theme } = param;
    return {
        alignSelf: 'center',
        marginRight: 8,
        fontSize: '2.6rem',
        [theme.breakpoints.up('md')]: {
            marginRight: 23
        }
    };
});
const CustomerOrdersModal = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require(/* webpackChunkName: "customer-orders-modal" */ './CustomerOrdersModal'))));
const CustomerOrderItem = (param)=>{
    let { 'data-testid': testId, color, text, title, handleOpenModal, handleCloseModal, shouldShowModal, ordersAmount, pendingOrders, ordersPageLink } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BlockLink, {
        "data-testid": testId,
        onClick: handleOpenModal,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ColoredBadge.ColoredBadge, {
                itemTheme: color
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(MerchContentWrapper, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MerchHeader, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MerchContent, {
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrowIcon, {
                "data-testid": "".concat(testId, "-arrow")
            }),
            shouldShowModal ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Loading.Loading, {}),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomerOrdersModal, {
                    "data-testid": "".concat(testId, "-modal"),
                    isOpen: shouldShowModal,
                    ordersAmount: ordersAmount !== null && ordersAmount !== void 0 ? ordersAmount : 0,
                    pendingOrders: pendingOrders !== null && pendingOrders !== void 0 ? pendingOrders : [],
                    ordersPageLink: ordersPageLink,
                    onClose: handleCloseModal
                })
            }) : null
        ]
    });
};
exports.CustomerOrderItem = CustomerOrderItem;
